import {observer} from 'mobx-react-lite';
import {useService} from "../../../../infrastructure/service/service";
import {Card, CardContent, Typography} from '@mui/material';
import React, {useEffect, useState} from "react";
import {User} from "../../../../entity/model/user";
import {ProfileCardProps} from "../../../../entity/props/authentication/profile-card-props";

import '../../../../assets/css/authentication/profile-card.css';

const ProfileCard = (props: ProfileCardProps): JSX.Element => {
  const {userService} = useService();

  const [currentUser, setCurrentUser] = useState<User>();

  useEffect(() => {
    const init = async (): Promise<void> => {
      const user = await userService.getCurrentUser();
      setCurrentUser(user);
    }

    init();
  }, [])

  return (
      <>
          <Card elevation={0} className={'profile-card'}>
              <CardContent className={'profile-card-content'}>
                  <Typography variant='h5' component='div' className={'profile-card-title'}>
                      <span>Hello</span>
                      {currentUser ? ', ' + currentUser.firstName + ' ' + currentUser.lastName : ''}
                  </Typography>
                  <Typography variant='body2' className={'profile-card-body'}>
                      You have { props.dueToday === 0 ? 'no' : props.dueToday} task{props.dueToday === 1 ? '' : 's'} due today and { props.dueThisWeek === 0 ? 'no' : props.dueThisWeek} task{props.dueThisWeek === 1 ? '' : 's'} due this week.
                  </Typography>
              </CardContent>
          </Card>
      </>
  );
}

export default observer(ProfileCard);
